<section
  class="analytics-card"
  aria-labelledby="security-events-title"
>
  <div class="card-header-row">
    <h2
      class="card-title"
      id="security-events-title"
    >
      Threats by Type
    </h2>
    <span class="card-total"><b>{{ total() | number }}</b> total</span>
  </div>

  <div class="breakdown">
    <svg
      class="donut"
      role="img"
      viewBox="0 0 180 180"
      [attr.aria-label]="ariaLabel()"
    >
      <g
        transform="rotate(-90 90 90)"
        fill="none"
        stroke-width="26"
      >
        @for (event of events(); track event.value) {
          <circle
            cx="90"
            cy="90"
            r="60"
            [attr.stroke]="event.color"
            [attr.stroke-dasharray]="event.dash + ' ' + circumference"
            [attr.stroke-dashoffset]="event.offset"
          ></circle>
        }
      </g>
      <text
        x="90"
        y="92"
        text-anchor="middle"
        class="donut-total"
      >
        {{ total() | number }}
      </text>
      <text
        x="90"
        y="110"
        text-anchor="middle"
        class="donut-label"
      >
        threats
      </text>
    </svg>

    <div class="legend">
      @for (event of events(); track event.value) {
        <div class="legend-item">
          <span
            class="legend-dot"
            [style.background]="event.color"
          ></span>
          <span class="legend-name">{{ event.value }}</span>
          <b>{{ event.count | number }}</b>
          <span class="legend-pct">{{ event.pct }}%</span>
        </div>
      }
    </div>
  </div>
</section>
